import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useEditPaymentProvider } from '../api/editPaymentProvider';
import { Fields } from '../hooks/usePaymentProviderForm';

import { PaymentProviderForm } from './PaymentProviderForm';

type EditModalProps = {
  paymentProviderId: string;
  initialValues: Fields;
};

export const EditModal = NiceModal.create(
  ({ initialValues, paymentProviderId }: EditModalProps) => {
    const modal = useModal();

    const { mutate, isLoading } = useEditPaymentProvider({
      department: initialValues.department,
      onSuccess: modal.hide,
    });

    return (
      <Modal
        centered
        overlayProps={{ opacity: 0.4, blur: 1.5 }}
        opened={modal.visible}
        onClose={() => modal.remove()}
        title="Редактирование платежного провайдера"
      >
        <PaymentProviderForm
          isLoading={isLoading}
          onSubmit={(params) => mutate({ ...params, _id: paymentProviderId })}
          initialValues={initialValues}
        />
      </Modal>
    );
  }
);
